const urlName = '/raas/course/v1'
export default API => ({
    //课程列表
    findManageList({ data, params }) {
        return API({
            url: `${urlName}/course/findManageList` ,
            params,
            data
        });
    },
    //课程详情
    findById({ data, params }) {
        return API({
            url: `${urlName}/course/findById` ,
            params,
            data
        });
    },
    //课程详情保存
    save({ data }) {
        return API({
            url: `${urlName}/course/save`,
            method:'post',
            data
        });
    },
    //目录详情
    getValidCourseChapterInfo({ data, params }) {
        return API({
            url: `${urlName}/courseChapter/getValidCourseChapterInfo` ,
            params,
            data
        });
    },
    delete({ params }) {
        return API({
            url: `${urlName}/course/delete`,
            method:'get',
            params
        });
    },
    //课程发布
    publish({ params }) {
        return API({
            url: `${urlName}/course/publish`,
            method:'get',
            params
        });
    },
    //取消课程发布
    cancelpublish({ params }) {
        return API({
            url: `${urlName}/course/unPublish`,
            method:'get',
            params
        });
    },
    // 课程终止
    cancelCourse(id){
        return API({
            url: `${urlName}/course/forcedTermination?courseId=${id}`,
            method:'get'
        });
    },
    coursecopy({ params }) {
        return API({
            url: `${urlName}/course/copy`,
            method:'get',
            params
        });
    },
    courseChaptersave({ data }) {
        return API({
            url: `${urlName}/courseChapter/save`,
            method:'post',
            data
        });
    },
    saveAndPublish({ data }) {
        return API({
            url: `${urlName}/courseChapter/saveAndPublish`,
            method:'post',
            data
        });
    }
    
})
